const ArrowLeft = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-arrow-left"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-arrow-left"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M19,11H9l3.29-3.29a1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0l-4.29,4.3A2,2,0,0,0,6,12H6a2,2,0,0,0,.59,1.4l4.29,4.3a1,1,0,1,0,1.41-1.42L9,13H19a1,1,0,0,0,0-2Z" />
    </svg>
  );
};

export default ArrowLeft;
